import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 素材列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	manageList( params={} ) {
		return request({
	    url: baseUrl + '/screen/mediaList',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 素材修改
	**/
	manageEdit(id,data){
		return request({
			url: baseUrl + '/screen/mediaList/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 素材删除
	**/
	manageDel(id){
		return request({
			url: baseUrl + '/screen/mediaList/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 素材添加
	**/
	manageAdd(data){
		return request({
			url: baseUrl + '/screen/mediaList',
			method:'POST',
			data
		})
	}
}